<!--{{filteredOptions | json}}-->
<div class="d-flex flex-wrap align-items-start mb-6">
  <label *ngIf="label" for="{{ controlName }}" class="col-12 col-lg-4 col-form-label {{ required ? 'required' : '' }}">{{ label }}</label>
  <div class="col-12 col-lg-8">
    <div class="position-relative">
      <input
        matInput
        [placeholder]="placeholder"
        [formControl]="control"
        [matAutocomplete]="auto"
        class="form-control form-control-solid"
        [class.border-danger]="invalidAndDirty"
        (blur)="handleOnBlur()"
        #trigger="matAutocompleteTrigger"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
        <mat-option *ngFor="let option of filteredOptions" [value]="option" [disabled]="option?.disabled"> {{ option.code }}, {{ option.label }} </mat-option>
      </mat-autocomplete>
      <span class="svg-icon svg-icon-1 cursor-pointer" [inlineSVG]="ICONS.IC_ARROW_MINI_DOWN" (click)="trigger.openPanel(); $event.stopPropagation()"></span>
    </div>

    <mat-error *ngIf="invalidAndDirty && hasErrors">
      <div class="px-2 mt-2">
        {{ displayErrorMessage(controlName) }}
      </div>
    </mat-error>
  </div>
</div>
